'use strict';

angular.module('msUtility').service('uuidSvc', [function () {

  function newUuid() {
    return window.uuid.v4();
  }

  return {
    newUuid: newUuid
  };
}]);